import * as _ from "lodash"

import {
  ISearch,
  ISearchProfile,
  ISearchProvider,
  HorizAlignment,
  SearchProviderFieldType,
  ISearchProviderField, ISearchRequestSubset, ITree, IProfileFilter, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";

import {WB_CustomerRow, WB_ModelingSessionRefRRow} from "../PA.Core/PAdbSchemaRows";
import {ASync} from "../PA.Core/Basic/ASync";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {CustomerSearch} from "../PA.UIM.MD/CustomerSearch";


const vWB_RefR_Fields: {[id:string]: ISearchProviderField } = {
  WB_MODELING_SESSION_REFR_ID:  {type: SearchProviderFieldType.number, renderOptions: { columnName: 'RefR WB Id',               columnResourceName: 'colRefRWBId',              alignment: HorizAlignment.Center}, domainOptions: { }},
  WB_MODELING_SESSION_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Modeling Session WB Id',   columnResourceName: 'colModelingSessionWBId',   alignment: HorizAlignment.Center}, domainOptions: { }},
  WB_CUST_ID:                   {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Customer WB Id',           columnResourceName: 'colCustWBId',              alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
  CUSTOMER_NAME:                {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Name',            columnResourceName: 'colCustName',              alignment: HorizAlignment.Left},   domainOptions: { profileId: "ModelingSessionRefValuesByListSearchProfile", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
  PRODUCT_NAME:                 {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Name',             columnResourceName: 'colProdName',              alignment: HorizAlignment.Left},   domainOptions: { profileId: "ModelingSessionRefValuesByListSearchProfile", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
  WB_PROD_ID:                   {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Prod WB Id',               columnResourceName: 'colProdWBId',              alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
  PRODUCT_GROUP_NAME:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Group Name',       columnResourceName: 'colPrdGrpName',            alignment: HorizAlignment.Left}, domainOptions: { profileId: "ModelingSessionRefValuesByListSearchProfile", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
  WB_PRDGRP_ID:                 {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Product Group WB Id',      columnResourceName: 'colPrdGrpWBId',            alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
MODEL_PREDICTOR_NAME:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Predictor Name',           columnResourceName: 'colPredictorName',         alignment: HorizAlignment.Left}, domainOptions: { profileId: "ModelingSessionRefValuesByListSearchProfile", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
  WB_MODEL_PREDICTOR_ID:        {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Predictor WB Id',          columnResourceName: 'colPredictorWBId',         alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
  REF_VALUE:                    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Reference Value',          columnResourceName: 'colRefVal',                alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
}

const vWB_RefR_KeyFields =
  {id:    'WB_MODELING_SESSION_REFR_ID',
   id_ui: '',
   name:  ''}


class ModelingSessionRefValuesByListSearchProvider
  implements  ISearchProvider {

  arrWB_Modeling_Session_RefR_Ids: number[] = []
  modelingSessionWBId: number = -1
  _searchProviderFields: {[id:string]: ISearchProviderField } = {}

  constructor(WB_Modeling_Session_Id: number, WB_ModelingSessionRefR_Ids: number[],  aSearch: ISearch){
    this.modelingSessionWBId = WB_Modeling_Session_Id
    this.arrWB_Modeling_Session_RefR_Ids = WB_ModelingSessionRefR_Ids
    this._searchProviderFields = _.cloneDeep(vWB_RefR_Fields)
    _.forEach(this._searchProviderFields, (value, key) => {
      value.domainOptions.search = aSearch
    })
  }

  get keyFields() { return vWB_RefR_KeyFields }

  get searchProviderFields(){
    return this._searchProviderFields
  }

  search(requestSpec: ISearchRequestSubset): Promise<any[]> {
    const self = this
    return new Promise<any[]>((resolve, error) => {

      requestSpec.where.WB_MODELING_SESSION_ID = this.modelingSessionWBId

      /*if(this.arrWB_Modeling_Session_RefR_Ids.length > 0)
        requestSpec.where.WB_MODELING_SESSION_REFR_ID = {nin: this.arrWB_Modeling_Session_RefR_Ids}*/

      let findRequest = SearchUtils.makeSearchRequest(requestSpec,
          'vUI_Modeling_Session_RefR_Search' , //
          self.searchProviderFields,
          [])

      PASearch.findByRequest(findRequest)
          .then((res: any[]) => {
            resolve(res)
          })
          .catch((err)=> {
            error(err)
          })
    })
  }

  distinctValues(fieldName: string): Promise<string[] | number[]> {
    const self = this
    return new Promise<string[] | number[]>((resolve, error) => {
      let findRequest = SearchUtils.makeSearchRequest({
            "where": {
              "WB_MODELING_SESSION_ID": this.modelingSessionWBId
              }
            },
          'vUI_Modeling_Session_RefR_Search',
          self.searchProviderFields,
          [fieldName])

      PASearch.findByRequest(findRequest)
          .then((res: any[]) => {

            resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
          })
          .catch((err)=> {
            error(err)
          })
    })
  }

}


class ModelingSessionRefValuesByListSearchProfile
  implements  ISearchProfile {

  aSearchProvider: ISearchProvider = undefined

  profileId = "default"
  profileName = "AutoSearch Only"
  renderOptions = { ui5ResourceId: "ModelingSessionRefValuesByListProfile" }

  profileFilter: IProfileFilter[] = [
      {profileFilterName: 'Customer', searchProviderFieldId: 'CUSTOMER_NAME', bMultiSelect: true, renderOptions: { }},
    {profileFilterName: 'Product', searchProviderFieldId: 'PRODUCT_GROUP_NAME', bMultiSelect: true, renderOptions: { }},
    {profileFilterName: 'Predictor', searchProviderFieldId: 'MODEL_PREDICTOR_NAME', bMultiSelect: true, renderOptions: { }}
  ]

  profileDisplayFields = [
    'CUSTOMER_NAME','PRODUCT_GROUP_NAME', 'MODEL_PREDICTOR_NAME','REF_VALUE'
  ]

  profileTreeIdDefault = "default"
  profileTrees: ITree[] = [
    {treeId: "default",
      treeName: "By Hierarchy",
      nodeProviders: [ new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "No Customer Tree Path Set", levelDelimiter: "\\", ruggedTree: true})],
      renderOptions: {}}
  ]

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault = ""    //string;
  profileSorts: ISearchSort[] = [] //ISearchSort[];


  constructor(WB_Modeling_Session_Id: number, WB_ModelingSessionRefR_Ids: number[], aSearch: ISearch){
    this.aSearchProvider = new ModelingSessionRefValuesByListSearchProvider(WB_Modeling_Session_Id, WB_ModelingSessionRefR_Ids, aSearch)
  }

  get profileSearchProvider(){ return this.aSearchProvider }

}


export class ModelingSessionRefValuesByList
  implements  ISearch {

  constructor(WB_Modeling_Session_Id: number, WB_ModelingSessionRefR_Ids: number[], options?: any){
    this.searchProfiles = [ new ModelingSessionRefValuesByListSearchProfile(WB_Modeling_Session_Id, WB_ModelingSessionRefR_Ids, this) ]
  }

  searchName = "Select ModelingSessionRefValues(s)"
  renderOptions = { ui5ResourceId: "ModelingSessionRefValuesByList"}
  searchProfileIdDefault = "default"
  searchProfiles: ISearchProfile[] = []
  autoSearch = true

}
